import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=0c1b56f2&scoped=true"
import script from "./InfoIcon.vue?vue&type=script&lang=js"
export * from "./InfoIcon.vue?vue&type=script&lang=js"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=0c1b56f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b56f2",
  null
  
)

export default component.exports